import 'react';
import { BsFonts } from '@react-icons/all-files/bs/BsFonts';
import { LIGHT_THEME } from '@bucketplace/design-system';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Text as Text$1 } from './Text.js';
import { TextInspector } from './Text.Inspector.js';
import { jsx } from '@emotion/react';

var Text = decorateComponent(Text$1, 'block', {
  id: 'text',
  label: '텍스트',
  defaultProps: {
    size: 13,
    color: LIGHT_THEME.content.base1,
    weight: 'lighter',
    align: 'left',
    background: 'none'
  },
  allowedChildren: [],
  disallowedAncestors: ['carousel'],
  renderIcon: function renderIcon() {
    return jsx(BsFonts, null);
  },
  renderTitle: function renderTitle(_ref) {
    var value = _ref.value;
    return "".concat(value || '내용없는 텍스트');
  },
  renderInspector: TextInspector
});

export { Text as default };
//# sourceMappingURL=index.js.map
